"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function request(isScan) {
    return {
        state: "requested",
        isScan: isScan,
    };
}
exports.request = request;
function missing() {
    return {
        state: "missing",
        isScan: false,
    };
}
exports.missing = missing;
function cached(isScan, value) {
    return {
        state: "cached",
        isScan: isScan,
        value: value,
    };
}
exports.cached = cached;
function refresh(key) {
    return __assign({}, key, { expiration: "refreshing" });
}
exports.refresh = refresh;
function expire(key) {
    return __assign({}, key, { expiration: "expired" });
}
exports.expire = expire;
//# sourceMappingURL=stored-key-utils.js.map


// WEBPACK FOOTER //
// ../src/stored-key-utils.ts